import axios from "axios";
import { SERVER_URL } from "../../config";
import { Authorization } from "../authorization";
import { Affiliate } from "../../models/affiliate";
import { Token } from "../../models/token";
import { Voucher } from "../../models/voucher";
import { UpdateUser } from "../../models/user";
import { SubscriptionData } from "../../models/subscription";
import { PaymentIntentData } from "../../models/paymentIntent";

export const checkRecordingToken = async (token: string) => {
  let res = null;
  try {
    res = await axios.get<Token>(SERVER_URL + "/recordingToken/check?token=" + token);
  } catch (e) { }
  return res;
}


export const validateVoucher = async (voucherCode: string) => {
  let res = null;
  try {
    res = await axios.get<Voucher>(SERVER_URL + "/validateVoucher", {
      params: { voucherCode: voucherCode },
      headers: { Authorization: await Authorization.AuthToken() }
    });
  } catch (e) { }
  return res;
}

export const updateUser = async (saveData: UpdateUser) => {
  return await axios.put(SERVER_URL + "/user", saveData, {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });
}

export const getCurrentUser = async () => {
  return await axios.get(SERVER_URL + "/user/current", {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });
}

export const getAffiliateById = async (affiliateId: string) => {
  return await axios.get<Affiliate>(SERVER_URL + "/affiliate", { params: { affiliateId } });
}

export const getAffiliateByUrl = async (url: string) => {
  return await axios.get<Affiliate>(SERVER_URL + "/affiliate/url", { params: { url: url } });
}

//Obsolete. Video processing is triggered by successful socked disconnect with 1000 status.
// export const combineVideo = async (videoId: string) => {
//   return await axios.post(SERVER_URL + "/video/combine", { videoId }, {
//     headers: {
//       Authorization: await Authorization.AuthToken()
//     }
//   });
// }

// payment

